<template>
  <div class="page">
    <mt-header fixed :title="title" style="height: 40px">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
    </mt-header>
    <div class="list">
      <div
        :class="['item', !item.withdraw_enable ? 'disabled' : '']"
        v-for="(item, index) in networkList"
        :key="item.id"
        @click="active = index"
      >
        <div
          class="name"
          :style="{ color: !item.withdraw_enable ? '#959698' : '' }"
        >
          {{ item.name }}
        </div>
        <div
          class="network"
          :style="{ color: !item.withdraw_enable ? '#959698' : '' }"
        >
          {{ item.network }}
        </div>
        <div :class="['radio', active === index ? 'checked' : '']"></div>
      </div>
    </div>
    <div class="btn">
      <mt-button
        size="large"
        type="primary"
        :disabled="(!active && active !== 0) || active == -1"
        @click="receive"
        >{{ $t("确定") }}</mt-button
      >
      <!-- 加入判断不选择网络无法进入发送币界面 -->
    </div>
    <div
      class="tip"
      v-if="networkList[active] && networkList[active].withdraw_tips"
    >
      {{ networkList[active].withdraw_tips }}
    </div>
  </div>
</template>

<script>
import { httpAccountNetworkList } from "@/api/index";
export default {
  data() {
    return {
      title: "",
      coin_symbol: "",
      display_coin_symbol: "",
      price: "",
      category: "",
      symbolId: "",
      networkList: [],
      active: null,
    };
  },
  activated() {
    this.title =
      this.$route.query.display_coin_symbol + " " + this.$t("提币网络");
    this.coin_symbol = this.$route.query.coin_symbol;
    this.price = this.$route.query.price;
    this.category = this.$route.query.category;
    this.display_coin_symbol = this.$route.query.display_coin_symbol;
    this.symbolId = this.$route.query.symbol_id;
    this.getNetworkList()
  },
  methods: {
    receive() {
      this.$router.push({
        path: "/send",
        query: {
          coin_symbol: this.coin_symbol,
          price: this.price,
          category: this.category,
          display_coin_symbol: this.display_coin_symbol,
          symbolId: this.symbolId,
          network: this.networkList[this.active].network,
          coin: this.networkList[this.active].coin,
          memo_required: this.networkList[this.active].memo_required,
        },
      });
    },
    
    // 获取提币网络的地址校验规则
    getNetworkList() {
      httpAccountNetworkList({coin_symbol: this.coin_symbol})
        .then((res) => {
          this.networkList = res.data;
          this.active = this.networkList.findIndex((item) => item.withdraw_enable);
          window.LS.set("withdraw_network", res.data);
          this.withdrawIntDetail = this.active;
        })
        .catch();
    },
  },
};
</script>

<style scoped>
.page {
  padding-top: 40px;
  height: 100vh;
  overflow: auto;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.list {
  padding: 15px;
}
.item {
  position: relative;
  border: 1px solid #1b85d7;
  border-radius: 15px;
  padding: 10px 15px;
  margin: 10px 0;
}
.item.disabled {
  opacity: 0.8;
  border-color: #ddd;
  pointer-events: none;
}
.item.disabled {
  border-color: #eee;
  opacity: 0.8;
  pointer-events: none;
}
.network {
  font-size: 14px;
  margin-top: 5px;
  opacity: 0.8;
}
.btn {
  padding: 15px;
}
.radio {
  position: absolute;
  top: 50%;
  right: 15px;
  margin-top: -10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #e8e8f8;
}
.radio::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  background-color: #fff;
  transition: transform 0.3s;
  transform: translate3d(-4px, -4px, 0) scale(0.5);
  border-radius: 50%;
  box-sizing: border-box;
  opacity: 0;
}
.radio.checked {
  background-color: #1b85d7;
}
.radio.checked::after {
  opacity: 1;
  transform: translate3d(-4px, -4px, 0) scale(1);
}
.tip {
  padding: 15px;
  font-size: 14px;
  margin-bottom: 80px;
}
/deep/ .mint-header-title {
  overflow: inherit;
}
</style>
